import { render, staticRenderFns } from "./LayoutTwoColumn.vue?vue&type=template&id=a1dc8416"
import script from "./LayoutTwoColumn.vue?vue&type=script&lang=js"
export * from "./LayoutTwoColumn.vue?vue&type=script&lang=js"
import style0 from "./LayoutTwoColumn.vue?vue&type=style&index=0&id=a1dc8416&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports